import { lazy, Suspense, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/UI/Layout";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import ScrollToTop from "./components/UI/ScrollToTop";

const ParticleCursor = lazy(() => import("./components/ParticleCursor"));
const Privacy = lazy(() => import("./components/pages/Privacy"));
const TermsService = lazy(() => import("./components/pages/TermsService"));
const ContactUs = lazy(() => import("./components/pages/ContactUs"));
const DeletePage = lazy(() => import("./components/pages/DeletePage"));
const DealPage = lazy(() => import("./components/pages/DealPage"));
const Faq = lazy(() => import("./components/pages/Faq"));

function App() {
  const [showCursor, setShowCursor] = useState(false);

  useEffect(() => {
    const supportsFinePointer =
      window.matchMedia("(pointer: fine)").matches &&
      window.matchMedia("(hover: hover)").matches;
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (!supportsFinePointer || prefersReducedMotion) return;

    const enableCursor = () => setShowCursor(true);
    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(enableCursor, { timeout: 1800 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(enableCursor, 700);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <Suspense fallback={null}>{showCursor ? <ParticleCursor /> : null}</Suspense>
      <Navbar />
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<TermsService />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/delete-account" element={<DeletePage />} />
            <Route path="/faq" element={<Faq />} />
          </Route>
          <Route path="/deal/:dealId" element={<DealPage />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
